import { createContext, useContext } from 'react';
import { BitbucketInstallationContextValue } from './types';

export const BitbucketInstallationContext = createContext<
  BitbucketInstallationContextValue | undefined
>(undefined);

/**
 * Hook to access the Bitbucket installation wizard context.
 *
 * Provides state for workspace selection, installation, repositories, and webhook results.
 *
 * @throws Error if used outside BitbucketInstallationContext.Provider
 */
export const useBitbucketInstallation = () => {
  const context = useContext(BitbucketInstallationContext);

  if (!context) {
    throw new Error(
      'useBitbucketInstallation must be used within BitbucketInstallationContext.Provider',
    );
  }

  return context;
};
